export const header = ['Subjects', 'Theory Score', 'Theory Total', 'Practical Score', 'Practical Total', 'Total Score', 'Grade', 'Percentage'] as string[];

export const reportStatusOption = [
  {
    id: 1,
    name: 'PASS',
  },
  {
    id: 2,
    name: 'FAIL',
  },
];

export const boardOptions = [
  {
    id: 1,
    name: 'CBSE',
  },
  {
    id: 2,
    name: 'Indian Certificate of Secondary Education (ICSE)',
  },
  {
    id: 3,
    name: 'International Baccalaureate (IB)',
  },
  {
    id: 4,
    name: 'Cambridge International Examinations (CIE)',
  },
  {
    id: 5,
    name: 'State Board of Maharashtra',
  },
  {
    id: 6,
    name: 'State Board of Tamil Nadu',
  },
  {
    id: 7,
    name: 'State Board of Karnataka',
  },
  {
    id: 8,
    name: 'State Board of West Bengal',
  },
  {
    id: 9,
    name: 'State Board of Rajasthan',
  },
  {
    id: 10,
    name: 'State Board of Uttar Pradesh',
  },
];

export const headingStyle = { fontSize: '14px', fontWeight: 'bold' };

export const blankResult = {
  className: '',
  section: '',
  examYear: new Date().getFullYear().toString(),
  examMonth: new Date().toLocaleString('default', { month: 'long' }),
  resultStatus: '',
  board: '',
  admissionId: '',
  examTitle: '',
  name: '',
  fatherName: '',
  motherName: '',
  dateOfBirth: '',
  photo: '',
  rollNo: '',
  teacherRemarks: '',
  studentRank: '',
  marks: [],
};
